import clsx from 'clsx';
import { ReactNode } from 'react';
import classes from './DisabledContainer.module.scss';

export default function DisabledContainer({
  children,
  isDisabled = true,
}: {
  children: ReactNode;
  isDisabled?: boolean;
}) {
  return (
    <div className={clsx(classes.root, isDisabled && classes.disabled)}>
      {children}
    </div>
  );
}
